
const logger = console;

export class ElasticSearchFilter {

  /**
   * filter not where clause - these are fields that should not match in the query.
   * return false if any of the values in the not where clause match
   */
  public static filterNotWhere(filterDocument, notWhereClause) {

    for (let i = 0; i < notWhereClause.length; i++) {
      // return false if any of the values in the not where clause match

      const key = notWhereClause[i].key;
      const filterDocumentValue = filterDocument[key];

      if (Array.isArray(filterDocumentValue)) {

        for (let j = 0; j < filterDocumentValue.length; j++) {

          if (notWhereClause[i].value === filterDocumentValue[j]) {
            return false;
          }
        }
      } else if (notWhereClause[i].value === filterDocumentValue) {
        return false;
      }
    }

    // there are no matching conditions to the not-where
    return true;
  }

  /**
   * filter should clause - these are fields where a minimum number of shoulds need to match the condition. So if minimum_should_match
   * is 1 then 1 of the should statements needs to match. If minimum_should_match is 0 then none of them need to match but the score
   * is impacted in standard ElasticSearch. In our case 0 will mean none of them need to match so we don't need to check them.
   * We don't currently do the score but if we do in the future we'll need to start checking them
   */
  public static filterShould(filterDocument, shouldClause, minimumShouldMatch) {

    // if minimumShouldMatch is 0, no filtering is required - it only impacts the score
    // but doesn't stop documents from showing. We don't have the score in IndexedDB at
    // this stage

    if (minimumShouldMatch === 0 || shouldClause.length === 0) {

      return true;
    } else {

      let numMatches = 0;

      for (let i = 0; i < shouldClause.length; i++) {
        // return false if the number of values matching the should is less than minimum_should_match

        const key = shouldClause[i].key;
        const filterDocumentValue = filterDocument[key];

        if (Array.isArray(filterDocumentValue)) {

          for (let j = 0; j < filterDocumentValue.length; j++) {

            if (shouldClause[i].value === filterDocumentValue[j]) {

              // use the prefix ++ so the value is incremented before checking
              if (++numMatches >= minimumShouldMatch) {
                return true;
              }
            }
          }
        } else if (shouldClause[i].value === filterDocumentValue) {

          // use the prefix ++ so the value is incremented before checking
          if (++numMatches >= minimumShouldMatch) {
            return true;
          }
        }
      }
    }

    // there are no matching conditions to the not-where
    return false;
  }

  /**
   * filter range clause
   * @param filterDocument - filterDocument
   * @param rangeQueries - rangeQueries
   * @returns boolean - the result
   */
  public static filterRange(filterDocument, rangeQueries, isNotClause) {

    if (rangeQueries && rangeQueries.length > 0) {

      for (let i = 0; i < rangeQueries.length; i++) {

        const keys = Object.keys(rangeQueries[i]);

        for (let j = 0; j < keys.length; j++) {

          const key = keys[j];
          const result = this.checkRange(rangeQueries[i][key], filterDocument[key]);

          if (isNotClause && result) { // range in must_not query

            return false;
          } else if (!isNotClause && !result) { // range in must query

            return false;
          }
        }
      }
    }

    return true;
  }

  private static checkRange(rangeEntry, fieldValue) {

    const lessThanValue = rangeEntry.lt;
    const lessOrEqualValue = rangeEntry.lte;
    const greaterThanValue = rangeEntry.gt;
    const greaterOrEqualValue = rangeEntry.gte;

    let result = true;
    if (fieldValue !== undefined) {

      if (lessOrEqualValue && greaterOrEqualValue) {
        result = fieldValue <= lessOrEqualValue &&

          fieldValue >= greaterOrEqualValue;

      } else if (lessOrEqualValue) {

        result = fieldValue <= lessOrEqualValue;

      } else if (greaterOrEqualValue) {

        result = fieldValue >= greaterOrEqualValue;
      }

      if (lessThanValue && greaterThanValue) {

        result = fieldValue < lessThanValue &&
          fieldValue > greaterThanValue;

      } else if (lessThanValue) {

        result = fieldValue < lessThanValue;
      } else if (greaterThanValue) {

        result = fieldValue > greaterThanValue;
      }
    } else {

      result = false;
    }

    return result;
  }

}
